export const csvEncode = (text) => {
    if (text == null) {
        return '';
    }
    text = text.toString();
    text = text.replaceAll(/\r?\n/g, ' ');
    if (text.includes('"') || text.includes(',')) {
        text = `"${text.replaceAll('"', '""')}"`;
    }
    return text;
}
export const csvParseLine = line => {
    if (line?.charCodeAt(0) === 0xFEFF) {
        line = line.slice(1);
    }

    const result = [];
    const len = line?.length;

    if (!len) {
        return null;
    }

    let field = '';
    for (let i = 0, inQuotes = false; i < len; i++) {
        const ch = line[i];

        if (inQuotes) {
            if (ch === '"') {
                if (i + 1 < len && line[i + 1] === '"') {
                    field += '"';
                    i++; // skip escaped quote
                } else {
                    inQuotes = false; // closing quote
                }
            } else {
                field += ch;
            }
        } else if (ch === '"') {
            inQuotes = true;
        } else if (ch === ',') {
            result.push(field);
            field = '';
        } else {
            field += ch;
        }
    }

    result.push(field); // push last field

    return result;
}